import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { GroupService } from '../../services/group.service';

@Component({
    selector: 'app-update-group',
    templateUrl: './update-group.component.html',
    styleUrls: ['./update-group.component.css', '../../app.component.css']
})

export class UpdateGroupComponent implements OnInit {

    groupForm: FormGroup;
    group: any = [];

    id: string;

    ggSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private groupService: GroupService) {
        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.ggSubs = this.groupService.getGroup(this.id).subscribe(groupObj => {
                this.ggSubs.unsubscribe();

                this.group = groupObj;
            });

            
        });
    }

    ngOnInit() {
        this.groupForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required]
        });
    }

    onSubmitGroup() {
        this.group = this.saveGroup();

        this.groupService.putGroup(this.group, this.id).then(res => {
            this.router.navigate(['/groups']);
        });
    }

    saveGroup() {
        const groupJson = {
            description: this.groupForm.get('description').value,
            name: this.groupForm.get('name').value,
            updatedAt: new Date()
        };

        return groupJson;
    }

}
